import {entityDelete, entitySave, executeCall} from "./CallService";

export const taskListRange = async (startDate, endDate) => {
    const action = "query";
    const data = {
        query: "taskListWeek",
        params: {
            startDate: startDate,
            endDate: endDate
        }
    };
    return await executeCall(action, data);
};

export const taskFavoritesList = async (projectId) => {
    const action = "query";
    const data = {
        query: "taskFavoritesList",
        params: {
            projectId: projectId
        }
    };
    return await executeCall(action, data);
};

export const taskSearchList = async(type, searchParams, current) => {
    const action = "query.dml";
    const data = {
        query: "taskSearchList",
        type: type,
        current: current,
        params: searchParams
    };
    return await executeCall(action, data);
};

export const taskSave = async(dbValues) => {
    return entitySave("project_task", dbValues);
}

export const taskDelete = async(taskId) => {
    return entityDelete("project_task", taskId);
}

export const taskClearedUpdate = async (taskId, taskCleared) => {
    const action = "query.dml";
    const data = {
        query  : "updateTaskCleared",
        id     : taskId,
        cleared: taskCleared
    };
    return await executeCall(action, data);
};
